function xtransport() {
 var _container;
 var _canvas;
 var _scaleType; // 'remote', 'scale', 'downscale'
 var _callback;
 var _rfb;
 var _rfb_state;
 var _resizeTimeout;
 var _isTouchDevice = false;
 var _settings = {
  encrypt: false,
  true_color: true,
  cursor: true,
  shared: true,
  view_only: false,
  repeaterID: ''
 };
 var _encodes;
 this.init = function(container, canvas, scaleType, settings, protocolencodings, callback) {
  _container = container;
  _canvas = canvas;
  _scaleType = scaleType;
  _callback = callback;
  _settings = settings;
  _encodes = protocolencodings;
  Util.addEvent(window, 'resize', function () {
   onresize();
  });
  
  try {
   _rfb = new RFB({'target': $D(canvas),
                   'onUpdateState': updateState,
                   'onXvpInit': _callback.updateXvpVisualState,
                   'onClipboard': _callback.clipReceive,
                   'onFBUComplete': FBUComplete,
                   'onFBResize': updateViewDrag,
                   'onDesktopName': _callback.updateDocumentTitle}, _callback.onSendData);
      return true;
  } catch (exc) {
      _callback.updateState(null, 'fatal', null, 'Unable to create RFB client -- ' + exc);
      return false;
  }
 }
 
 this.connect = function() {
  _rfb.set_encrypt(_settings.encrypt);
  _rfb.set_true_color(_settings.true_color);
  _rfb.set_local_cursor(_settings.cursor);
  _rfb.set_shared(_settings.shared);
  _rfb.set_view_only(_settings.view_only);
  _rfb.set_repeaterID(_settings.repeaterID);
  if(_encodes.length > 0){
    if(_rfb._encodings) _rfb._encodings = _encodes;
  }
  _rfb.connect('localhost', 5900, '', '');
 }
 
 this.disConnect = function() {
	_rfb.disconnect(); 
	 onresize();
	_rfb.set_onFBUComplete(function() { });
 }
 this.onReceiveData = function(data) {
  // Forward received data from X Transport
  _rfb._sock._recv_message(data);
 },
 
 onresize = function() {
  if (!_rfb) return;

  var size = getCanvasLimit();

  if (size && _rfb_state === 'normal' && _rfb.get_display()) {
      var display = _rfb.get_display();
      if (_scaleType === 'remote') {
       // use remote resizing

       // When the local window has been resized, wait until the size remains
       // the same for 0.5 seconds before sending the request for changing
       // the resolution of the session
       clearTimeout(_resizeTimeout);
       _resizeTimeout = setTimeout(function(){
         display.set_maxWidth(size.w);
         display.set_maxHeight(size.h);
         Util.Debug('Attempting setDesktopSize(' +
                    size.w + ', ' + size.h + ')');
           
         _rfb.setDesktopSize(size.w, size.h);
       }, 500);
      } else if (_scaleType === 'scale' || _scaleType === 'downscale') {
       // use local scaling

       var downscaleOnly = _scaleType === 'downscale';
       var scaleRatio = display.autoscale(size.w, size.h, downscaleOnly);
       _rfb.get_mouse().set_scale(scaleRatio);
       Util.Debug('Scaling by ' + _rfb.get_mouse().get_scale());
      }
  }
 }
 
 getCanvasLimit = function () {
  var container = $D(_container);

  // Hide the scrollbars until the size is calculated
  container.style.overflow = "hidden";

  var pos = Util.getPosition(container);
  var w = pos.width;
  var h = pos.height;

  container.style.overflow = "visible";

  if (isNaN(w) || isNaN(h)) {
      return false;
  } else {
      return {w: w, h: h};
  }
 }
 
 updateState = function(rfb, state, oldstate, msg) {
  _rfb_state = state;
  _callback.updateState(rfb, state, oldstate, msg);
 }
 this.sendButtonKeyEvent = function(id) {
   _rfb.sendKey(id,true);
   _rfb.sendKey(id,false);
   return false;
 }
 // This resize can not be done until we know from the first Frame Buffer Update
 // if it is supported or not.
 // The resize is needed to make sure the server desktop size is updated to the
 // corresponding size of the current local window when reconnecting to an
 // existing session.
 FBUComplete = function(rfb, fbu) {
  onresize();
  _rfb.set_onFBUComplete(function() { });
 }
 
 // Update the viewport drag/move button
 updateViewDrag = function(drag) {
  if (!_rfb) return;

  // Check if viewport drag is possible
  if (_rfb_state === 'normal' &&
      _rfb.get_display().get_viewport() &&
      _rfb.get_display().clippingDisplay()) {

   _callback.updateViewDrag(true, true);
  } else {
   // The VNC content is the same size as
   // or smaller than the display

   if (_rfb.get_viewportDrag) {
    // Turn off viewport drag when it's
    // active since it can't be used here
    
    // RAVI: what to do here?
    // vmb.className = "noVNC_status_button";
    _rfb.set_viewportDrag(false);
   }

   // Disable or hide the drag button
   if (_rfb_state === 'normal' && _isTouchDevice) {
    _callback.updateViewDrag(true, false);
   } else {
    _callback.updateViewDrag(false);
   }
   return;
  }

  if (typeof(drag) !== "undefined" &&
      typeof(drag) !== "object") {
   if (drag) {
    // RAVI: what to do here?
    // vmb.className = "noVNC_status_button_selected";
    _rfb.set_viewportDrag(true);
   } else {
    // RAVI: what to do here?
    // vmb.className = "noVNC_status_button";
    _rfb.set_viewportDrag(false);
   }
  }
 }
}

/* 
// Use this callback object on the GUI to get events from novnc

var uiInterfaceCallback = {
 onSendData: function(data) {
  // Send data over X transport
 },
 
 updateState: function(rfb, state, oldstate, msg) {
   var klass;
   switch (state) {
   case 'failed':
   case 'fatal':
    klass = "noVNC_status_error";
    break;
   case 'normal':
    klass = "noVNC_status_normal";
    break;
   case 'disconnected':
    // falls through
   case 'loaded':
    klass = "noVNC_status_normal";
    break;
   case 'password':
    klass = "noVNC_status_password";
    break;
   default:
    klass = "noVNC_status_warn";
    break;
   }

   // Make use of klass to update UI
 },

 // Disable/enable XVP button
 updateXvpVisualState: function(ver) {
  if (ver >= 1) {
   // show xvp
  } else {
   // hide xvp
  }
 },

 clipReceive: function(rfb, text) {
  // process clipboard text
 },
 
 // Update the viewport drag/move button
 updateViewDrag: function(show, enable) {
 },
 
 // Display the desktop name in the document title
 updateDocumentTitle: function(rfb, name) {
 },
 
}*/

/*** EXPORTS FROM exports-loader ***/
module.exports = xtransport;